import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Layout } from './components/Layout';
import { LoadingBlock } from './components/ui';
import { useAuth } from './lib/auth';

import { LoginPage } from './pages/Login';
import { ForgotPasswordPage, ResetPasswordPage } from './pages/PasswordReset';
import { ChangePasswordPage } from './pages/ChangePassword';
import { DashboardPage } from './pages/Dashboard';
import { ProjectsPage, ProjectDetailPage } from './pages/Projects';
import { ClientsPage, ClientDetailPage } from './pages/Clients';
import { ClientFormPage, ClientContactFormPage } from './pages/ClientForm';
import { ProjectFormPage } from './pages/ProjectForm';
import { CancelPenaltyPage, DecideObjectionPage, ObjectPenaltyPage, VoidViolationPage } from './pages/ViolationForm';
import { DepartmentFormPage, DepartmentMemberFormPage } from './pages/DepartmentForm';
import { EmployeeDeletePage } from './pages/EmployeeDelete';
import { EmployeeFormPage } from './pages/EmployeeForm';
import { TicketFormPage } from './pages/TicketForm';
import { TicketActionFormPage } from './pages/TicketActionForm';
import { TaskAssignPage, TaskDeadlinePage, TaskEditPage, TaskFormPage } from './pages/TaskForm';
import { TaskReturnBackPage, TaskReturnPage } from './pages/TaskReturn';
import { TaskWorkflowEditPage } from './pages/TaskWorkflowEdit';
import { QTaskFormPage, QTaskActionPage, QTaskAssignPage, QTaskConvertPage, QTaskEditPage } from './pages/QTaskForm';
import {
  ShiftDayFormPage,
  GenerateRosterFormPage,
  CopyRosterFormPage,
  ShiftDefinitionFormPage,
  ShiftDefinitionRemovePage,
  HolidayFormPage,
  HolidayDeletePage,
} from './pages/ShiftForm';
import { TasksPage } from './pages/Tasks';
import { LeaderTasksPage } from './pages/LeaderTasks';
import { LeaderTaskFormPage, LeaderTaskHandOnPage, LeaderTaskReassignPage } from './pages/LeaderTaskForm';
import { TaskDetailPage } from './pages/TaskDetail';
import { AttendancePage } from './pages/Attendance';
import { DeviceActionPage, EndSessionFormPage } from './pages/AttendanceForm';
import { RejectBreakRequestPage } from './pages/BreakRequests';
import { AttendanceShiftPage } from './pages/AttendanceShift';
import { AttendanceEmployeePage } from './pages/AttendanceEmployee';
import { LeavesPage } from './pages/Leaves';
import { LeaveDetailPage } from './pages/LeaveDetail';
import { LeaveRequestFormPage, RejectLeaveFormPage } from './pages/LeaveForm';
import { OvertimePage } from './pages/Overtime';
import { OvertimeDetailPage } from './pages/OvertimeDetail';
import { OvertimeAnswerPage, OvertimeFormPage } from './pages/OvertimeForm';
import { RemoteWorkPage } from './pages/RemoteWork';
import { RemoteWorkDetailPage } from './pages/RemoteWorkDetail';
import { RejectRemoteWorkFormPage, RemoteWorkFormPage } from './pages/RemoteWorkForm';
import { BreakTypeFormPage, LeaveTypeFormPage } from './pages/SettingsTypeForm';
import { KanbanPage } from './pages/Kanban';
import { TicketsPage } from './pages/Tickets';
import { TicketDetailPage } from './pages/TicketDetail';
import { QTasksPage, QTaskDetailPage } from './pages/QTasks';
import { AnnouncementsPage, AnnouncementDetailPage } from './pages/Announcements';
import { ClientCrsPage, ClientCrDetailPage } from './pages/ClientCrs';
import { ClientCrConvertPage, ClientCrStatusPage } from './pages/ClientCrForm';
import { ClientComplaintDetailPage, ClientComplaintStatusPage, ClientComplaintsPage } from './pages/ClientComplaints';
import { AnnouncementDeletePage, AnnouncementFormPage } from './pages/AnnouncementForm';
import { MailboxPage, MailDetailPage } from './pages/Mail';
import { ComposeMailPage } from './pages/MailCompose';
import { ChatPage } from './pages/Chat';
import { NotesPage, TodosPage } from './pages/Notes';
import { MeetingsPage } from './pages/Meetings';
import { MeetingDetailPage } from './pages/MeetingDetail';
import { MeetingFormPage, MeetingNotePage } from './pages/MeetingForm';
import { MeetingBookingPage } from './pages/MeetingBooking';
import { AddToCallPage, CallsPage, NewCallPage } from './pages/Calls';
import { CallDetailPage } from './pages/CallDetail';
import { DriveEveryonePage, DriveFilePage, DriveFolderPage, DriveOwnerPage, DrivePage } from './pages/Drive';
import { DriveEditPage, DriveFolderFormPage, DriveMovePage, DriveSendPage, DriveSharePage } from './pages/DriveForms';
import { SitePage, SitesPage } from './pages/Sites';
import { SiteAnalyticsPage } from './pages/SiteAnalytics';
import { SiteDeletePage, SiteEditorPage, SiteFileMovePage, SiteFormPage, SiteNewFolderPage } from './pages/SiteForms';
import { ShiftsPage } from './pages/Shifts';
import { GiveSupportModePage } from './pages/SupportMode';
import { MySchedulePage } from './pages/MySchedule';
import { MyPayslipsPage } from './pages/MyPayslips';
import { WalletPage } from './pages/Wallet';
import { WalletRedeemPage } from './pages/WalletRedeem';
import { DepartmentsPage, DepartmentDetailPage } from './pages/Departments';
import { EmployeesPage, EmployeeDetailPage } from './pages/Employees';
import { ViolationsPage } from './pages/Violations';
import { PenaltyDetailPage } from './pages/PenaltyDetail';
import { ShortfallDetailPage } from './pages/ShortDays';
import { ShortfallDecidePage, ShortfallReversePage } from './pages/ShortDayForms';
import { PointsGrantPage, RewardCancelPage, RewardFormPage, RewardsPage } from './pages/Rewards';
import { AiPointsPage } from './pages/AiPoints';
import { AiPointsDetailPage } from './pages/AiPointsDetail';
import { AiPointsRejectPage, AiPointsRetryPage, AiPointsRunRetryPage } from './pages/AiPointsForms';
import { ReportsPage } from './pages/Reports';
import { SettingsPage } from './pages/Settings';
import { ExecutiveAccessGrantPage, ExecutiveAccessRevokePage } from './pages/ExecutiveAccessForms';
import { AuditLogPage } from './pages/AuditLog';
import { MobileActivityPage } from './pages/MobileActivity';
import { ChatStickersPage, StickerPackFormPage } from './pages/ChatStickers';
import { MonitoringServerDetailPage, MonitoringServersPage } from './pages/MonitoringServers';
import { MonitoringServerFormPage } from './pages/MonitoringServerForm';
import { MonitoringUrlDetailPage, MonitoringUrlsPage } from './pages/MonitoringUrls';
import { MonitoringUrlFormPage } from './pages/MonitoringUrlForm';
import { MonitoringAlertsPage } from './pages/MonitoringAlerts';
import { MonitoringRecipientFormPage } from './pages/MonitoringRecipientForm';
import { MonitoringSettingsPage } from './pages/MonitoringSettings';
import { MonitoringOverviewPage } from './pages/MonitoringOverview';
import { MonitoringIncidentsPage } from './pages/MonitoringIncidents';
import { NotFoundPage } from './pages/NotFound';

export function App() {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();

  // Forgot password's two pages are open to anyone, signed in or not: the email's link lands on one.
  if (pathname === '/forgot-password') return <ForgotPasswordPage />;
  if (pathname === '/reset-password') return <ResetPasswordPage />;

  if (loading) {
    return (
      <div className="grid h-full place-items-center">
        <LoadingBlock />
      </div>
    );
  }

  if (!user) return <LoginPage />;

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />

        {/* Internal mail between employees. A key per folder, so each starts at its own first page. */}
        <Route path="/mail" element={<MailboxPage key="inbox" folder="inbox" />} />
        <Route path="/mail/sent" element={<MailboxPage key="sent" folder="sent" />} />
        <Route path="/mail/trash" element={<MailboxPage key="trash" folder="trash" />} />
        <Route path="/mail/new" element={<ComposeMailPage />} />
        <Route path="/mail/:id" element={<MailDetailPage />} />

        {/* Chat between two employees, under Mail — one page for the list and the open chat, so
            moving between chats keeps the list where it was (operator, 2026-10-19). */}
        <Route path="/chat/:id?" element={<ChatPage />} />

        {/* Everyone's own sticky notes and to-do list, two pages — theirs alone (operator, 2026-10-15). */}
        <Route path="/notes" element={<NotesPage />} />
        <Route path="/todos" element={<TodosPage />} />
        {/* The meeting calendar, under My to-do list (2026-10-21): everyone asked accepts or declines. */}
        <Route path="/meetings" element={<MeetingsPage />} />
        <Route path="/meetings/new" element={<MeetingFormPage />} />
        <Route path="/meetings/booking" element={<MeetingBookingPage />} />
        <Route path="/meetings/:id" element={<MeetingDetailPage />} />
        <Route path="/meetings/:id/edit" element={<MeetingFormPage />} />
        <Route path="/meetings/:id/decline" element={<MeetingNotePage key="decline" action="decline" />} />
        <Route path="/meetings/:id/cancel" element={<MeetingNotePage key="cancel" action="cancel" />} />
        {/* Calls, under the meeting calendar (2026-10-29): New call, My history, All calls for the
            administrators, and each call's page with its recording. Every call is recorded. */}
        <Route path="/calls" element={<CallsPage />} />
        <Route path="/calls/new" element={<NewCallPage />} />
        <Route path="/calls/add" element={<AddToCallPage />} />
        <Route path="/calls/:id" element={<CallDetailPage />} />
        {/* Viganium Drive, under Calls (2026-11-02): everyone's own folders and files — My Drive, Shared with
            me, the Trash — each folder's and file's page, and their forms. Shared with employees, with
            everyone, by a public link, by email to a client's contacts. A key per list, as Mail's folders. */}
        <Route path="/drive" element={<DrivePage key="mine" view="mine" />} />
        <Route path="/drive/shared" element={<DrivePage key="shared" view="shared" />} />
        <Route path="/drive/trash" element={<DrivePage key="trash" view="trash" />} />
        {/* Every employee's drive, opened and shared — the administrators' (drive.view_all). */}
        <Route path="/drive/everyone" element={<DriveEveryonePage />} />
        <Route path="/drive/everyone/:userId" element={<DriveOwnerPage />} />
        <Route path="/drive/new-folder" element={<DriveFolderFormPage />} />
        <Route path="/drive/folders/:id" element={<DriveFolderPage />} />
        <Route path="/drive/files/:id" element={<DriveFilePage />} />
        <Route path="/drive/:id/edit" element={<DriveEditPage />} />
        <Route path="/drive/:id/move" element={<DriveMovePage />} />
        <Route path="/drive/:id/share" element={<DriveSharePage />} />
        <Route path="/drive/:id/send" element={<DriveSendPage />} />
        {/* Sites, under Drive (2026-11-03): websites in folders of their own, published at
            sites.<domain>/<folder>/ — the administrators', and whoever Settings › Sites picks. The new and
            the edited file are each their own page (a key each), so a file made goes on as one edited. */}
        <Route path="/sites" element={<SitesPage />} />
        <Route path="/sites/new" element={<SiteFormPage />} />
        <Route path="/sites/:id" element={<SitePage />} />
        <Route path="/sites/:id/analytics" element={<SiteAnalyticsPage />} />
        <Route path="/sites/:id/edit" element={<SiteFormPage />} />
        <Route path="/sites/:id/delete" element={<SiteDeletePage />} />
        <Route path="/sites/:id/new-folder" element={<SiteNewFolderPage />} />
        <Route path="/sites/:id/new-file" element={<SiteEditorPage key="new" creating />} />
        <Route path="/sites/:id/edit-file" element={<SiteEditorPage key="edit" />} />
        <Route path="/sites/:id/files/:fileId/move" element={<SiteFileMovePage />} />

        <Route path="/clients" element={<ClientsPage />} />
        {/* Form routes come before `:id` so "new" is never read as an id. */}
        <Route path="/clients/new" element={<ClientFormPage />} />
        <Route path="/clients/:id" element={<ClientDetailPage />} />
        <Route path="/clients/:id/edit" element={<ClientFormPage />} />
        <Route path="/clients/:id/contacts/new" element={<ClientContactFormPage />} />
        <Route path="/clients/:id/contacts/:contactId/edit" element={<ClientContactFormPage />} />

        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/new" element={<ProjectFormPage />} />
        <Route path="/projects/:id" element={<ProjectDetailPage />} />
        <Route path="/projects/:id/edit" element={<ProjectFormPage />} />
        <Route path="/tasks" element={<TasksPage />} />
        <Route path="/tasks/new" element={<TaskFormPage />} />
        <Route path="/tasks/:id" element={<TaskDetailPage />} />
        <Route path="/tasks/:id/deadline" element={<TaskDeadlinePage />} />
        <Route path="/tasks/:id/edit" element={<TaskEditPage />} />
        <Route path="/tasks/:id/assign" element={<TaskAssignPage />} />
        <Route path="/tasks/:id/reassign" element={<TaskAssignPage />} />
        {/* A workflow's step back to someone earlier to check something, and back again (2026-10-15). */}
        <Route path="/tasks/:id/return" element={<TaskReturnPage />} />
        <Route path="/tasks/:id/return-back" element={<TaskReturnBackPage />} />
        {/* The levels a running workflow has not reached yet, changed (2026-10-15). */}
        <Route path="/tasks/:id/workflow" element={<TaskWorkflowEditPage />} />
        {/* Leaders Tasks are tasks: their page, editing and deadline are the task pages'. */}
        <Route path="/leader-tasks" element={<LeaderTasksPage />} />
        <Route path="/leader-tasks/new" element={<LeaderTaskFormPage />} />
        <Route path="/leader-tasks/:id" element={<TaskDetailPage />} />
        <Route path="/leader-tasks/:id/edit" element={<TaskEditPage />} />
        <Route path="/leader-tasks/:id/deadline" element={<TaskDeadlinePage />} />
        <Route path="/leader-tasks/:id/hand-on" element={<LeaderTaskHandOnPage />} />
        <Route path="/leader-tasks/:id/reassign" element={<LeaderTaskReassignPage />} />
        <Route path="/kanban" element={<KanbanPage />} />
        <Route path="/client-crs" element={<ClientCrsPage />} />
        <Route path="/client-crs/:id" element={<ClientCrDetailPage />} />
        <Route path="/client-crs/:id/status" element={<ClientCrStatusPage />} />
        <Route path="/client-crs/:id/convert" element={<ClientCrConvertPage />} />
        <Route path="/client-complaints" element={<ClientComplaintsPage />} />
        <Route path="/client-complaints/:id" element={<ClientComplaintDetailPage />} />
        <Route path="/client-complaints/:id/status" element={<ClientComplaintStatusPage />} />
        <Route path="/tickets" element={<TicketsPage />} />
        <Route path="/tickets/new" element={<TicketFormPage />} />
        <Route path="/tickets/:id" element={<TicketDetailPage />} />
        <Route path="/tickets/:id/edit" element={<TicketFormPage />} />
        <Route path="/tickets/:id/:action" element={<TicketActionFormPage />} />
        <Route path="/q-tasks" element={<QTasksPage />} />
        <Route path="/q-tasks/new" element={<QTaskFormPage />} />
        <Route path="/q-tasks/:id" element={<QTaskDetailPage />} />
        <Route path="/q-tasks/:id/edit" element={<QTaskEditPage />} />
        <Route path="/q-tasks/:id/assign" element={<QTaskAssignPage />} />
        <Route path="/q-tasks/:id/convert" element={<QTaskConvertPage />} />
        <Route path="/q-tasks/:id/:action" element={<QTaskActionPage />} />
        <Route path="/announcements" element={<AnnouncementsPage />} />
        <Route path="/announcements/new" element={<AnnouncementFormPage />} />
        <Route path="/announcements/:id" element={<AnnouncementDetailPage />} />
        <Route path="/announcements/:id/edit" element={<AnnouncementFormPage />} />
        <Route path="/announcements/:id/delete" element={<AnnouncementDeletePage />} />

        <Route path="/shifts" element={<ShiftsPage />} />
        <Route path="/shifts/day" element={<ShiftDayFormPage />} />
        <Route path="/shifts/generate" element={<GenerateRosterFormPage />} />
        <Route path="/shifts/copy" element={<CopyRosterFormPage />} />
        <Route path="/shifts/definitions/new" element={<ShiftDefinitionFormPage />} />
        <Route path="/shifts/definitions/:id/edit" element={<ShiftDefinitionFormPage />} />
        <Route path="/shifts/definitions/:id/remove" element={<ShiftDefinitionRemovePage />} />
        <Route path="/shifts/holidays/new" element={<HolidayFormPage />} />
        <Route path="/shifts/holidays/:id/edit" element={<HolidayFormPage />} />
        <Route path="/shifts/holidays/:id/delete" element={<HolidayDeletePage />} />
        {/* Support mode (2026-11-01): support hours on chosen days; one day's are set on its day page above. */}
        <Route path="/shifts/support/new" element={<GiveSupportModePage />} />
        <Route path="/my-schedule" element={<MySchedulePage />} />
        <Route path="/my-payslips" element={<MyPayslipsPage />} />
        {/* Everyone's own points wallet, from the menu under their name (2026-10-20); a redemption is confirmed on its own page. */}
        <Route path="/wallet" element={<WalletPage />} />
        <Route path="/wallet/redeem/:type" element={<WalletRedeemPage />} />
        <Route path="/account/password" element={<ChangePasswordPage />} />
        <Route path="/attendance" element={<AttendancePage />} />
        <Route path="/attendance/sessions/:id" element={<AttendanceShiftPage />} />
        {/* An employee's month of shifts, from their name on the team board (2026-10-27). */}
        <Route path="/attendance/employees/:id" element={<AttendanceEmployeePage />} />
        <Route path="/attendance/sessions/:id/end" element={<EndSessionFormPage />} />
        <Route path="/attendance/devices/:id/disable" element={<DeviceActionPage action="disable" />} />
        <Route path="/attendance/devices/:id/remove" element={<DeviceActionPage action="remove" />} />
        <Route path="/attendance/break-requests/:id/reject" element={<RejectBreakRequestPage />} />
        <Route path="/leaves" element={<LeavesPage />} />
        <Route path="/leaves/new" element={<LeaveRequestFormPage />} />
        <Route path="/leaves/:id" element={<LeaveDetailPage />} />
        <Route path="/leaves/:id/reject" element={<RejectLeaveFormPage />} />
        {/* Overtime: a leader sends it, an administrator approves it, the employee accepts it (2026-10-21). */}
        <Route path="/overtime" element={<OvertimePage />} />
        <Route path="/overtime/new" element={<OvertimeFormPage />} />
        <Route path="/overtime/:id" element={<OvertimeDetailPage />} />
        <Route path="/overtime/:id/reject" element={<OvertimeAnswerPage key="reject" action="reject" />} />
        <Route path="/overtime/:id/decline" element={<OvertimeAnswerPage key="decline" action="decline" />} />
        {/* Remote work: someone at the office asks; the team leader approves it, then an administrator (2026-10-28). */}
        <Route path="/remote-work" element={<RemoteWorkPage />} />
        <Route path="/remote-work/new" element={<RemoteWorkFormPage />} />
        <Route path="/remote-work/:id" element={<RemoteWorkDetailPage />} />
        <Route path="/remote-work/:id/reject" element={<RejectRemoteWorkFormPage />} />
        <Route path="/departments" element={<DepartmentsPage />} />
        <Route path="/departments/new" element={<DepartmentFormPage />} />
        <Route path="/departments/:id" element={<DepartmentDetailPage />} />
        <Route path="/departments/:id/edit" element={<DepartmentFormPage />} />
        <Route path="/departments/:id/members/new" element={<DepartmentMemberFormPage />} />
        <Route path="/employees" element={<EmployeesPage />} />
        <Route path="/employees/new" element={<EmployeeFormPage />} />
        <Route path="/employees/:id/edit" element={<EmployeeFormPage />} />
        <Route path="/employees/:id/delete" element={<EmployeeDeletePage />} />
        <Route path="/employees/:id" element={<EmployeeDetailPage />} />
        <Route path="/violations" element={<ViolationsPage />} />
        <Route path="/violations/:id/void" element={<VoidViolationPage />} />
        <Route path="/violations/penalties/:id" element={<PenaltyDetailPage />} />
        <Route path="/violations/penalties/:id/cancel" element={<CancelPenaltyPage />} />
        <Route path="/violations/penalties/:id/object" element={<ObjectPenaltyPage />} />
        <Route path="/violations/penalties/:id/objection/approve" element={<DecideObjectionPage decision="approve" />} />
        <Route path="/violations/penalties/:id/objection/reject" element={<DecideObjectionPage decision="reject" />} />
        {/* Days more than an hour short, an administrator's to decide (CR-004); deciding and reversing are pages. */}
        <Route path="/violations/short-days/:id" element={<ShortfallDetailPage />} />
        <Route path="/violations/short-days/:id/decide" element={<ShortfallDecidePage />} />
        <Route path="/violations/short-days/:id/reverse" element={<ShortfallReversePage />} />
        {/* Rewards of part of a day's pay, and points added by hand — the administrators' (CR-004). */}
        <Route path="/rewards" element={<RewardsPage />} />
        <Route path="/rewards/new" element={<RewardFormPage />} />
        <Route path="/rewards/points/new" element={<PointsGrantPage />} />
        <Route path="/rewards/:id/cancel" element={<RewardCancelPage />} />
        {/* AI daily points (CR-007): proposals made at 06:00, approved or rejected one by one — the administrators'. */}
        <Route path="/ai-points" element={<AiPointsPage />} />
        <Route path="/ai-points/runs/:id/retry" element={<AiPointsRunRetryPage />} />
        <Route path="/ai-points/:id" element={<AiPointsDetailPage />} />
        <Route path="/ai-points/:id/reject" element={<AiPointsRejectPage />} />
        <Route path="/ai-points/:id/retry" element={<AiPointsRetryPage />} />

        {/* Finance — payroll, expenses, invoices, payments, budgets and the CR-001
            data migration — lives in sys, the finance system, at its own address. */}

        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/audit-log" element={<AuditLogPage />} />
        <Route path="/mobile-activity" element={<MobileActivityPage />} />
        <Route path="/sticker-packs" element={<ChatStickersPage />} />
        <Route path="/sticker-packs/new" element={<StickerPackFormPage />} />
        <Route path="/sticker-packs/:id/edit" element={<StickerPackFormPage />} />
        {/* Monitoring — servers, the projects on them and their URLs; the administrators' (2026-10-20). */}
        <Route path="/monitoring" element={<MonitoringOverviewPage />} />
        <Route path="/monitoring/incidents" element={<MonitoringIncidentsPage />} />
        <Route path="/monitoring/servers" element={<MonitoringServersPage />} />
        <Route path="/monitoring/servers/new" element={<MonitoringServerFormPage />} />
        <Route path="/monitoring/servers/:id" element={<MonitoringServerDetailPage />} />
        <Route path="/monitoring/servers/:id/edit" element={<MonitoringServerFormPage />} />
        <Route path="/monitoring/urls" element={<MonitoringUrlsPage />} />
        <Route path="/monitoring/urls/new" element={<MonitoringUrlFormPage />} />
        <Route path="/monitoring/urls/:id" element={<MonitoringUrlDetailPage />} />
        <Route path="/monitoring/urls/:id/edit" element={<MonitoringUrlFormPage />} />
        <Route path="/monitoring/alerts" element={<MonitoringAlertsPage />} />
        <Route path="/monitoring/alerts/new" element={<MonitoringRecipientFormPage />} />
        <Route path="/monitoring/alerts/:id/edit" element={<MonitoringRecipientFormPage />} />
        <Route path="/monitoring/settings" element={<MonitoringSettingsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        {/* Settings › Executive Dashboard (CR-008): grant and revoke Dashboard Access, each its own page. */}
        <Route path="/settings/executive-access/:userId/grant" element={<ExecutiveAccessGrantPage />} />
        <Route path="/settings/executive-access/:userId/revoke" element={<ExecutiveAccessRevokePage />} />
        <Route path="/settings/break-types/new" element={<BreakTypeFormPage />} />
        <Route path="/settings/break-types/:id/edit" element={<BreakTypeFormPage />} />
        <Route path="/settings/leave-types/new" element={<LeaveTypeFormPage />} />
        <Route path="/settings/leave-types/:id/edit" element={<LeaveTypeFormPage />} />

        <Route path="/login" element={<Navigate to="/" replace />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Layout>
  );
}
